import { CSSProperties, memo } from 'react';
import {
  Box,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  withStyles
} from '@material-ui/core';
import { useStyles } from '@setvi/shared/components/s-table/styles/TableStyles';
import { TableHeaderCell } from '@setvi/shared/components/s-table/styles';
import { SortType } from '@setvi/shared/enums';
import { ColumnsType } from '@setvi/shared/types';
import { SCheckbox, SCheckboxProps } from '../../../../scheckbox';
import { SortIcon } from '../../../../sicons';

export interface TableHeaderProps {
  checkbox?: SCheckboxProps;
  /** This prop is used to add free space(checkbox width) instead of a checkbox to move the first column. In most cases it is used when the header does not have a checkbox and the table does. */
  checkboxFreeSpace?: boolean;
  handle?: boolean;
  sort?: {
    sortBy: string;
    orderBy: SortType;
    onChange: (sortBy: string) => void;
  };
  columns: ColumnsType;
  headerClass?: string;
  rowStyle?: CSSProperties;
  newDesign?: boolean;
}

const checkboxWidth = 24;

export const tableCheckboxStyle: CSSProperties = {
  width: checkboxWidth,
  maxWidth: checkboxWidth,
  minWidth: checkboxWidth,
  textAlign: 'center',
  boxSizing: 'content-box'
};

export const Header = withStyles({
  root: {
    borderRadius: 8,
    backgroundColor: '#EEF0F2'
  }
})(TableRow);

const TableHeader = ({
  checkboxFreeSpace,
  checkbox,
  sort,
  handle,
  columns,
  headerClass,
  rowStyle,
  newDesign
}: TableHeaderProps) => {
  const classes = useStyles();

  return (
    <TableHead className={headerClass}>
      <Header style={rowStyle}>
        {handle && (
          <TableHeaderCell newDesign={newDesign} style={tableCheckboxStyle} />
        )}
        {checkboxFreeSpace && (
          <TableHeaderCell newDesign={newDesign} style={tableCheckboxStyle} />
        )}
        {checkbox && !checkboxFreeSpace && (
          <TableHeaderCell newDesign={newDesign} style={tableCheckboxStyle}>
            <SCheckbox {...checkbox} />
          </TableHeaderCell>
        )}
        {columns?.map(column => {
          const isSorted = sort?.sortBy === column?.sortBy;

          return (
            <TableHeaderCell
              key={column.id}
              align={column.align}
              newDesign={newDesign}
              style={{
                flex: column?.width ? 'unset' : 1,
                width: column?.width,
                textAlign: column?.align,
                minWidth: column?.minWidth || 'min-content',
                maxWidth: column?.maxWidth
              }}>
              <Box
                className={column.sortBy && classes.sortable}
                style={{
                  margin: column?.align === 'center' ? 'auto' : 'unset'
                }}
                onClick={() =>
                  column.sortBy && sort?.onChange?.(column.sortBy)
                }>
                {column?.sortBy && (
                  <TableSortLabel
                    className={classes.sortIconWraper}
                    active={isSorted}
                    IconComponent={SortIcon}
                    direction={isSorted ? sort?.orderBy : SortType.ASC}>
                    <Typography noWrap>
                      {column?.label || ''}
                      {column?.required && (
                        <span className={classes.required}>*</span>
                      )}
                    </Typography>
                  </TableSortLabel>
                )}
                {!column?.sortBy && (
                  <Typography noWrap>
                    {column?.label || ''}
                    {column?.required && (
                      <span className={classes.required}>*</span>
                    )}
                  </Typography>
                )}
              </Box>
            </TableHeaderCell>
          );
        })}
      </Header>
    </TableHead>
  );
};

export default memo(TableHeader);
